<template>
  <div>
    <div class="row" v-if="shopObj">
      <div :class="$LEFT_COL">
        <PasswordProtection v-if="shopObj.password_enabled" full />
        <DisabledAlert name="AMP" to="amp_settings" v-if="db.status && !db.status.amp" full />
        <p class="section-title">AMP</p>
        <router-view v-if="routeReady"></router-view>
        <Loading v-else />
      </div>
      <div :class="$RIGHT_COL" ref="positionRef"></div>
      <iPhone :positionRef="positionRef" v-if="$mq !== 'sm' && positionRef" />
    </div>
    <Loading v-else />
  </div>
</template>

<script>
import { mapState } from 'vuex'
import iPhone from '@/components/iPhone'
import DisabledAlert from '@/components/DisabledAlert'
import PasswordProtection from '@/components/PasswordProtection'
import routeReady from '@/mixins/routeReady'
import iphone from '@/mixins/iphone'

export default {
  mixins: [ routeReady, iphone ],
  components: {
    iPhone,
    DisabledAlert,
    PasswordProtection
  },
  computed: mapState([ 'shopObj', 'db' ])
}
</script>
